import { render, staticRenderFns } from "./purchase-type-add-or-update.vue?vue&type=template&id=3193f9e8"
import script from "./purchase-type-add-or-update.vue?vue&type=script&lang=js"
export * from "./purchase-type-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports